module.exports = __webpack_public_path__ + "static/img/logo_1.81a588c8.png";